import React from "react";
import { FaPen, FaTrash } from "react-icons/fa";

const SubAdminTable = ({ subadmins, onDelete, onEdit, onManagePermissions }) => {
    if (!subadmins || subadmins.length === 0) {
        return (
            <div className="no-variants-message">
                <p>No Sub-Admins found.</p>
            </div>
        );
    }

    return (
        <div className="luxury-table-container">
            <table className="luxury-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Username</th>
                        <th>Role</th>
                        <th>Permissions</th>
                        <th style={{ textAlign: 'center' }}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {subadmins.map((s) => (
                        <tr key={s._id || s.id}>
                            <td style={{ fontWeight: "700", color: "#181c32" }}>{s.name}</td>
                            <td>{s.username}</td>
                            <td>
                                <span className="status-badge type-product" style={{ fontSize: '0.75rem' }}>
                                    {s.role}
                                </span>
                            </td>
                            <td>
                                <button 
                                    className="btn-add-product" 
                                    style={{ padding: '6px 12px', fontSize: '0.75rem', background: '#f1f1f1', color: '#333' }}
                                    onClick={() => onManagePermissions(s)}
                                >
                                    Manage Permissions
                                </button>
                            </td>
                            <td>
                                <div className="table-actions" style={{ justifyContent: 'center' }}>
                                    <button className="action-btn edit" onClick={() => onEdit(s)} title="Edit">
                                        <FaPen />
                                    </button>
                                    <button className="action-btn delete" onClick={() => onDelete(s._id || s.id)} title="Delete">
                                        <FaTrash />
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default SubAdminTable;
